import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/_Core/_Constants/api.constant';
import { AppConstant } from 'src/app/_Core/_Constants/app.constant';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  url: string;
  accessToken: any;
  token_type: any;
  token: string;
  parkDropDownDetails = new BehaviorSubject<any>([]);

  constructor(private apiService: ApiService) { }

  getauthorizationToken(): Observable<any> {
    this.url = APIs.getAuthToken;
    const paramObj = {
      client_id: environment.officeRndClientId,
      client_secret: environment.officeRndClientSecret,
      grant_type: "client_credentials",
      scope: "officernd.api.read officernd.api.write"
    };
    return this.apiService.get(this.url, paramObj).pipe(map(response => {
      return response;
    }));
  };

  getApiauthorizationToken(email, password): Observable<any> {
    this.url = APIs.getApiAuthToken;
    const paramObj = {
      email: email,
      Password: password
    };
    return this.apiService.post(this.url, paramObj).pipe(map(response => {
      // console.log(response);
      if (response.isValid) {
        localStorage.setItem('completeOjb', JSON.stringify(response.list));
        localStorage.setItem('Tokens', JSON.stringify(response.list[0].userDetail.TokenDetails))
        // localStorage.setItem(AppConstant.localStorage.token, response.list[0].token);
        return { status: response.isValid, data: response.data, isUserLocked: response.list[0].IsUserLocked };
      } else {
        return {
          status: response.isValid,
          data: response.errorMsg,
          isUserLocked: response.list ? response.list.userDetail.TokenDetails[0].IsUserLocked : false //Need to check
        };
      }

    }));
  };

  getTenantId(): Observable<any> {
    this.url = APIs.getUserDetail;
    const paramObj = {
    };
    return //this.apiService.get(this.url, paramObj).pipe(map(response => {
    //localStorage.setItem(AppConstant.localStorage.tenantId, response.data.t0200OrgEmployees[0]?.tenantId);
    //}));
  };

  getAdminToken(email): Observable<any> {
    this.url = APIs.getAdminDetails;
    const paramObj = {
      Email: email
    };
    return this.apiService.get(this.url, paramObj).pipe(map(response => {
      localStorage.setItem(AppConstant.localStorage.token, response.data);
      return response;
    }));
  };

  logoutToken(): Observable<boolean> {
    const paramObj = {
      token: localStorage.getItem(AppConstant.localStorage.token)
    };
    localStorage.clear();
    // return this.apiService.post(APIs.logoutToken + "/?token=" + paramObj.token, null).pipe(map(response => {
    //   return response.isValid;
    // }));
    return this.apiService.post(APIs.logoutToken, paramObj, null).pipe(map(response => {
      return response.isValid;
    }));
  }

  setToken(data) {
    localStorage.setItem(AppConstant.localStorage.token, data.token);
    localStorage.setItem('userType', data.userType);
    localStorage.setItem('tenantId', data.tenantID);
    localStorage.setItem('userId', data.userId);
  }



  getOverviewDetail(data) {
    return this.apiService.get(APIs.getOverviewTA, data).pipe(
      map((response) => {
        return response;
      })
    );
  }


  getLocationPark() {
    let userId = (localStorage.getItem('userId')) ? localStorage.getItem('userId') : 0
    return this.apiService.get(`${APIs.getLocationPark}?userId=${userId}`).pipe(map(response => {
      if (response.isValid) {
        this.parkDropDownDetails.next(response.list);
      }
      return response;
    }))
  }

  getLocByTenatId() {
    let tenantId = (localStorage.getItem('tenantId')) ? localStorage.getItem('tenantId') : 0
    return this.apiService.get(`${APIs.getLocParkByTenantId}?TenantId=${tenantId}`).pipe(map(response => {
      if (response.isValid) {
        this.parkDropDownDetails.next(response.list);
      }
      return response;
    }))
  }

  getParkDropDownDetails(): Observable<any> {
    return this.parkDropDownDetails.asObservable();
  }

  verifyEmailForApp(body: string) {
    return this.apiService.post(APIs.verifyEmailForApp + "/?emailid=" + encodeURIComponent(body)).pipe(map(response => {
      return response;
    }));
  }

  verifyLoginOtp(body?: any): Observable<any> {
    return this.apiService.post(APIs.verifyOtp, body).pipe(map(response => {
      return response;
    }));
  }

  changeLoginPassword(body?: any): Observable<any> {
    return this.apiService.post(APIs.changePassword, body).pipe(map(response => {
      return response;
    }));
  }

  taLoginOtpGeneration(body?: any): Observable<any> {
    return this.apiService.post(APIs.taOtpGeneration, body).pipe(map(response => {
      return response;
    }));
  }

  checkUserAuthentication(body?: any): Observable<any> {
    return this.apiService.post(APIs.checkAuthenticatedUser, body).pipe(map(response => {
      return response;
    }));
  }

  checkUserPasswordExp(body?: any): Observable<any> {
    return this.apiService.post(APIs.checkUserPasswordExpiry, body).pipe(map(response => {
      return response;
    }));
  }

  taLoginOtpForPortal(body?: any): Observable<any> {
    return this.apiService.post(APIs.taOtpGeneration, body).pipe(map(response => {
      return response;
    }));
  }

  generateOTPasswordExp(body?: any): Observable<any> {
    return this.apiService.post(APIs.generateOtp, body).pipe(map(response => {
      return response;
    }));
  }

}
